module.exports = __webpack_public_path__ + "static/media/round-check.6d2bcb10.svg";